module.exports = __webpack_public_path__ + "static/media/daibiao-content-6.e425b076.png";